export default __webpack_public_path__ + "static/media/RelianceGeneralInsurance.a7d44cd6.svg";